import { createAction } from '@reduxjs/toolkit';

export const openModifyOrganizationDialog = createAction(
  'organizationCharts/openModifyOrganizationDialog'
);

export const closeModifyOrganizationDialog = createAction(
  'organizationCharts/closeModifyOrganizationDialog'
);

export const closeProjectOrganizationView = createAction(
  'organizationCharts/closeProjectOrganizationView'
);

export const openConfirmDeleteOrganizationDialog = createAction(
  'organizationCharts/openConfirmDeleteOrganizationDialog'
);

export const closeConfirmDeleteOrganizationDialog = createAction(
  'organizationCharts/closeConfirmDeleteOrganizationDialog'
);

export const resetOrganizationChartPosition = createAction(
  'organizationCharts/resetOrganizationChartPosition'
);

export const resetOrganizationChartPositionComplete = createAction(
  'organizationCharts/resetOrganizationChartPositionComplete'
);

export const centerOnActiveEmployer = createAction(
  'organizationCharts/centerOnActiveEmployer'
);

export const centerOnActiveEmployerComplete = createAction(
  'organizationCharts/centerOnActiveEmployerComplete'
);

export const setChartLayoutDirection = createAction(
  'organizationCharts/setChartLayoutDirection'
);

export const setOrganizationBusinessIdToAdd = createAction(
  'organizationCharts/setOrganizationBusinessIdToAdd'
);

export const setOrganizationBusinessNameToAdd = createAction(
  'organizationCharts/setOrganizationBusinessNameToAdd'
);

export const setSubcontractorBusinessAddType = createAction(
  'organizationCharts/setSubcontractorBusinessAddType'
);

export const setSearchInputValue = createAction(
  'organizationCharts/setSearchInputValue'
);

export const setSelectedOrganizationChartMode = createAction(
  'organizationCharts/setSelectedOrganizationChartMode'
);

export const setShowEmployees = createAction(
  'organizationCharts/setShowEmployees'
);

export const setShowEmployeeNumber = createAction(
  'organizationCharts/setShowEmployeeNumber'
);

export const setShowEmployeeTaxNumber = createAction(
  'organizationCharts/setShowEmployeeTaxNumber'
);
export const setShowEmployeeDateOfBirth = createAction(
  'organizationCharts/setShowEmployeeDateOfBirth'
);

export const openConfirmRemoveEmployeeFromProjectDialog = createAction(
  'organizationCharts/openConfirmRemoveEmployeeFromProjectDialog'
);

export const closeConfirmRemoveEmployeeFromProjectDialog = createAction(
  'organizationCharts/closeConfirmRemoveEmployeeFromProjectDialog'
);

export const openEditOrganizationEmployeesDialog = createAction(
  'organizationCharts/openEditOrganizationEmployeesDialog'
);

export const closeEditOrganizationEmployeesDialog = createAction(
  'organizationCharts/closeEditOrganizationEmployeesDialog'
);
